import { createSlice } from '@reduxjs/toolkit';
import Pedestal1 from "assets/images/페데스탈1.jpg"
import Pedestal2 from "assets/images/페데스탈2.jpg"
import Pedestal3 from "assets/images/페데스탈3.jpg"
import Pedestal4 from "assets/images/페데스탈4.jpg"
import 부잔교1 from "assets/images/부잔교1.jpg"
import 부잔교2 from "assets/images/부잔교1.jpg"
import 슬립웨이1 from "assets/images/슬립웨이1.png"
import 슬립웨이2 from "assets/images/슬립웨이2.png"
import 슬립웨이3 from "assets/images/슬립웨이3.png"
import 크레인1 from "assets/images/크레인1.png"
import 크레인2 from "assets/images/크레인2.png"
import 드라이스택1 from "assets/images/드라이스택1.jpg"
import 드라이스택2 from "assets/images/드라이스택2.jpg"
import 드라이스택3 from "assets/images/드라이스택3.jpg"
import 드라이스택4 from "assets/images/드라이스택4.jpg"

const markers = [
  {
    id: 1,
    name: "페데스탈(Pedestal)",
    position: { lat: 37.5, lng: 15 },//이걸로 마커 위치를 조절
    imageUrl: [
      Pedestal1,
      Pedestal2,
      Pedestal3,
      Pedestal4,
    ],
    imgDesc: "마리나 시설의 선박 및 기타 기구에 전기, 조명, 수도를 공급하는 장치"
  },
  {
    id: 2,
    name: "부잔교(Floating pier)",
    position: { lat: 37.6, lng: 25 },
    imageUrl: [
      부잔교1,
      부잔교2,
    ],
    imgDesc: "조수 간만의 차이가 있는 곳에 조위에 관계 없이 선박을 계류하기 위하여 부체(Pontoon)을 이용하여 물 위에 뜨도록 만든 구조물"
  },
  {
    id: 3,
    name: "슬립웨이(slipway)",
    position: { lat: 37.7, lng: 45 },
    imageUrl: [
      슬립웨이1,
      슬립웨이2,
      슬립웨이3,
    ],
    imgDesc: "선박 등을 육상 또는 해상으로 옮기기 위한 경사로를 지칭하는 것으로 슬로프(Slope), 램프(Ramp), 선양장등의 명칭으로 사용"
  },
  {
    id: 4,
    name: "크레인(Crane)",
    position: { lat: 37.7, lng: 65 },
    imageUrl: [
      크레인1,
      크레인2,
    ],
    imgDesc: "요트를 수리등 필요에 의해서 해상에서 육상으로 올리거나 내리는 장비"
  },
  {
    id: 5,
    name: "드라이스택(Drystack)",
    position: { lat: 37.7, lng: 80 },
    imageUrl: [
      드라이스택1,
      드라이스택2,
      드라이스택3,
      드라이스택4,
    ],
    imgDesc: "육상에 선박을 호이스트(Hoist)와 랙(Rack), 지게차(Fork Lift)등을 이용하여 안전하게 보관 하는 장치"
  }
];
 
const getMarkersInfo = createSlice({
  name:'markerInfoSlice',
  initialState: {value : markers},
  reducers:{
    
    }
});



export default getMarkersInfo;